import React from 'react';

function NotFound404() {
  return (
    <div
      className="container d-flex justify-content-center align-items-center text-center"
      style={{ minHeight: '100vh' }}
      dir="rtl"
    >
      <div>
        <h1 className="display-1 text-danger">404</h1>
        <h3 className="mb-3">הדף שחיפשת לא נמצא</h3>
        <p className="text-muted mb-4">יכול להיות שהקישור שבור או שהדף הועבר למיקום אחר</p>
        <a href="/" className="btn btn-primary">חזרה לעמוד הבית</a>
      </div>
    </div>
  );
}

export default NotFound404;
